export default "__VITE_ASSET__B0KIK8$C__"